import React, { ChangeEventHandler, MouseEventHandler, MouseEvent, TouchEvent } from 'react';
import { styles } from './VideoControls.css';
import { PauseIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Pause';
import { PlayIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Play';
import { MuteIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Mute';
import { UnmuteIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Unmute';
import { FullscreenIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Fullscreen';

export type VideoControlsProps = {
  progress: number;
  currentTime: string;
  isMuted: boolean;
  isPlaying: boolean;
  onRequestFullscreen: MouseEventHandler<HTMLButtonElement>;
  onSeekStart: (event: MouseEvent | TouchEvent) => void;
  onSeekEnd: (event: MouseEvent | TouchEvent) => void;
  onSeek: ChangeEventHandler<HTMLInputElement>;
  onMute: MouseEventHandler<HTMLButtonElement>;
  onPlay: MouseEventHandler<HTMLButtonElement>;
};

export const VideoControls = ({
  progress,
  currentTime,
  isMuted,
  isPlaying,
  onMute,
  onPlay,
  onSeekStart,
  onSeekEnd,
  onSeek,
  onRequestFullscreen,
}: VideoControlsProps) => {
  return (
    <div className={styles.container}>
      <button className={styles.control} onClick={onPlay}>
        {isPlaying ? <PauseIcon /> : <PlayIcon />}
      </button>
      <button className={styles.control} onClick={onMute}>
        {isMuted ? <MuteIcon /> : <UnmuteIcon />}
      </button>
      <span className={styles.currentTime}>{currentTime}</span>
      <div className={styles.progressContainer}>
        <progress className={styles.progress} value={progress} max="100" />
        <input
          className={styles.scrubber}
          type="range"
          min="0"
          max="100"
          value={progress}
          onChange={onSeek}
          onMouseDown={onSeekStart}
          onMouseUp={onSeekEnd}
          onTouchStart={onSeekStart}
          onTouchEnd={onSeekEnd}
        />
      </div>
      <button className={styles.control} onClick={onRequestFullscreen}>
        <FullscreenIcon />
      </button>
    </div>
  );
};
